import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsYogaNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M32.495 46H10.8a11.87 11.87 0 01-4.462-.864C3.767 44.09 1.712 42.163.69 39.72a8.796 8.796 0 01.32-7.506l12.386-26.59.031-.062c1.234-2.353 3.445-4.124 6.095-4.984 2.648-.86 5.57-.758 8.14.286 2.571 1.045 4.626 2.973 5.648 5.416a8.796 8.796 0 01-.32 7.507L31.959 16h12.417c2.554 0 4.248 2.646 3.179 4.965L37.49 42.802A5.5 5.5 0 0132.495 46zM26.532 3.643a8.964 8.964 0 00-6.084-.211c-1.967.638-3.51 1.915-4.348 3.493L6.81 26.868l.267-.1c2.68-.965 5.642-.85 8.237.32a10.682 10.682 0 015.517 5.696l9.453-20.295.031-.063c.829-1.58.907-3.366.228-4.988-.684-1.633-2.103-3.02-4.01-3.795zm-7.966 32.359a7.418 7.418 0 00-.443-1.906 7.675 7.675 0 00-4.043-4.273 7.997 7.997 0 00-5.987-.232 7.722 7.722 0 00-4.38 3.95l-.01-.005a1.432 1.432 0 01-.018.037c-.829 1.58-.907 3.367-.228 4.99.683 1.632 2.103 3.018 4.01 3.794A8.87 8.87 0 0010.8 43h21.695a2.5 2.5 0 002.27-1.454L44.83 19.71a.5.5 0 00-.454-.709H30.561l-7.582 16.276a7.93 7.93 0 01-14.268.224l-.283-.562 2.678-1.352.284.562a4.93 4.93 0 007.176 1.854z"
        fill=""
      />
    </svg>
  )
);
SvgSportsYogaNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsYogaNormalLarge;
